import { Box } from "@mui/material"
import { memo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import { breadcrumbActions } from "../../redux/reducers/breadcrumb"


const BreadCrumb = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const breadcrumbs = useSelector(state => state.breadcrumb)

    const handleRedirect = (e,item,index) => {
        e.preventDefault()
        let url = `${item.pathname}?isRedirect=true${item.search}`
        //console.log(item)
        dispatch(breadcrumbActions.removeElement({key:item.pathname}))
        //console.log(url)
        navigate(url)
    }
    return <Box className='breadcrumbs'>
        <Box className='breadcrumbs-list'>
            <Box className='breadcrumb-item'>Reports</Box>
            {
                breadcrumbs.list.map((item,index) => (
                    <Link key={item.pathname} className='breadcrumb-item' onClick={e => handleRedirect(e,item,index)}>{item.title}</Link>
                ))
            }
        </Box>
    </Box>
}

export default memo(BreadCrumb)